import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import tshirts from "../../assets/images/fillers/t-shirts.svg";
import hoodie from "../../assets/images/fillers/hoodie.svg";
import tracksuit from "../../assets/images/fillers/tracksuit.svg";
import uniform from "../../assets/images/fillers/uniform.svg";
import babyclothes from "../../assets/images/fillers/babyclothes.svg";
import filler1 from "../../assets/images/fillers/filler1.svg"
import filler2 from "../../assets/images/fillers/filler2.svg"

const FeaturedProducts = () => {
  const products = [
    { id: 1, name: "T-Shirts", img: tshirts },
    { id: 2, name: "Winter Clothes", img: hoodie },
    { id: 3, name: "Sportswear", img: tracksuit },
    { id: 4, name: "Uniforms", img: uniform },
    { id: 5, name: "Children's Clothes", img: babyclothes },
  ];

  return (
    <section id="featured-section" className="pt-36 backdrop-blur-lg px-4 md:px-0 overflow-hidden">
      <div className=" container mx-auto text-center flex flex-col gap-16 h-full items-center relative">
        {/* Animated Title */}
        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
          className=" top-24 text-4xl font-bold text-gray-800 w-full "
        >
          Our Product Line
        </motion.h2>

        {/* Product Cards */}
        {products.map((product) => (
          <motion.div
            key={product.id}
            className=" productHolder w-full flex flex-row justify-center gap-16 items-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y:-50 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.5 }}
          >
            <motion.img
              src={product.img}
              alt={product.name}
              className="w-1/3"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            />
            <motion.h1
              className="text-4xl font-bold font-merriweather"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              {product.name}
            </motion.h1>
          </motion.div>
        ))}

        {/* Large Paragraph */}
        
      </div>
      <div className="py-24 relative flex  flex-col items-center  mt-6 w-full gap-6 ">
      <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
          className="  text-4xl font-bold text-center pb-12 text-gray-800  w-full "
        >
          Our Product Line
        </motion.h2>
      <motion.h1
          className="w-[90%] md:w-[60%] text-center font-merriweather"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <span className="highlight font-black">Unity Fabric Industries Ltd.</span> specializes in producing a diverse range of knitwear, including <span className="highlight">Polo shirts, Crew neck and V-neck T-shirts, Tank tops, Hooded jackets, Trousers, Shorts, Pants, and Boxers</span>. Catering to men, women, and children, our offerings span both casual and formal apparel. This extensive product range, combined with our commitment to quality and innovation, has established us as a trusted partner for some of the most reputable brands across <span className="highlight">Europe and the US</span>.
        </motion.h1>
        <div className="grid grid-cols-5 overflow-hidden gap-4 items-center justify-center ">
  {products.map((product, index) => (
    <div key={index} className="p-4 w-fit ">
      <img src={product.img} alt={product.name} className=" min-w-[80px] md:w-full  md:h-40 object-cover" />
      {/* <h1 className="text-xl font-bold mt-2">{product.name}</h1> */}
    </div>
  ))}
</div>
<img src={filler1} alt="" className="absolute -left-48 sm:-left-40 md:left-0 -top-5"/>
<img src={filler2} alt="" className="absolute -right-48 sm:-right-40 md:right-0  bottom-5 opacity-45"/>
</div>

    </section>
  );
};

export default FeaturedProducts;